/* eslint-disable no-param-reassign */
export default $root => {
  const $publisher = $root || document;

  return {
    beforeMount: ($el, binding) => {
      $el.clickOutsideEvent = event => {
        if (!($el === event.target || $el.contains(event.target))) {
          binding.value();
        }
      };
      $publisher.addEventListener("click", $el.clickOutsideEvent);
    },
    unmounted: $el => {
      $publisher.removeEventListener("click", $el.clickOutsideEvent);
    }
  };
};
